import { useContext } from 'react';
import { PropertyContext } from './PropertyContext';
export const usePropertyContext = () => {
  return useContext(PropertyContext);
};